// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import BannerMessageController from "./banner_message_controller"
application.register("banner-message", BannerMessageController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)
